<ng-container *ngIf="control; else skeleton">
<dk-ctl-sablon #sablonCmp
    [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode" [title]="title" [code]="code"
    [validationRules]="validationRulesMap" [validationV2]="validationV2" 
    (handleValueChange)="handleValueChange($event)" (codeChanges)="code = $event" [warningMessage]="warningMessage"
    (searchClick)="searchClick()"
    (clear)="clear()">
</dk-ctl-sablon>  
    <dx-popup *ngIf="crudPopupVisible"
    title="Cevap Verilecek Evraklar"
    [resizeEnabled]="false"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [(visible)]="crudPopupVisible"
    (onHiding)="closePopupAfter($event, sablonCmp)"
>

        <dk-ctl-bys-ilgi-gelen-arama 
        [control]="control"
        (closePopup)="closePopupAfter($event, sablonCmp)">
        </dk-ctl-bys-ilgi-gelen-arama>
</dx-popup>
<dx-toast [(visible)]="toastVisible" type="error" [message]="toastMessage">
</dx-toast>
</ng-container>
<ng-template #skeleton>
  <div class="skeleton-control"></div>
</ng-template>
